import { Image } from 'expo-image';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import Text from '@/components/Text';
import { BLUR_HASH } from '@/constants/layout';
import { useColor } from '@/hooks/useColor';

interface FavoriteCardProps {
  title: string;
  image: string;
  onPress: () => void;
}

const FavoriteCard = ({ title, image, onPress }: FavoriteCardProps) => {
  const colors = useColor();

  return (
    <TouchableOpacity onPress={onPress}>
      <View style={style.mainContainer}>
        <Text
          ellipsizeMode="tail"
          numberOfLines={1}
          style={[style.title, { color: colors.titleText }]}
          fontWeight="900">
          {title}
        </Text>
        <Image style={style.imageStyle} source={image} contentFit="cover" placeholder={{ blurhash: BLUR_HASH }} />
      </View>
    </TouchableOpacity>
  );
};

export default FavoriteCard;

const style = StyleSheet.create({
  mainContainer: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'flex-start'
  },

  title: {
    letterSpacing: -0.36,
    fontSize: 18
  },

  imageStyle: {
    height: 166,
    width: '100%',
    borderRadius: 10,
    marginVertical: 10
  },

  description: {
    fontSize: 12
  }
});
